import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteBranch, fetchBranches } from "../../../slices/company/branchSlice";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Delete, Pen } from "lucide-react";
import Swal from "sweetalert2";
import { customTableStyles } from "../../../utils/tableStylings";
import AddEditBranch from "./branch_form";

const Branches = () => {
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);

    const [selectedBranch, setSelectedBranch] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    // Retrieve branches data and loading/error states from the Redux store
    const { branches, loading, error } = useSelector((state) => state.branches);

    useEffect(() => {
        // Fetch branches when the component mounts
        dispatch(fetchBranches());
    }, [dispatch]);


    const handleEdit = (branchData) => {
        setSelectedBranch(branchData);
        setModalHeading('Edit Branch') // Pass the supplier data to edit
        setShowModal(true);
    };
    const handleDelete = (branchId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Branch.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteBranch(branchId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Branch has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };

    // Define table columns
    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1, // Display row index (1-based)
            sortable: false,
            width: "50px",
        },
        {
            name: "Branch Name",
            selector: (row) => row.branch_name,
            sortable: true,
        },
        {
            name: "Location",
            selector: (row) => row.branch_location,
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="d-flex justify-content-center gap-2">
                    <Link
                        className="text-success"
                        onClick={() => handleEdit(row)}
                    >
                        <Pen />
                    </Link>
                    <Link
                        className="text-danger"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </Link>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    // Filter branches based on the search term
    const filteredBranches = branches.filter((branch) =>
        branch.branch_name.toLowerCase().includes(search.toLowerCase()) ||
        branch.branch_location.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center gap-2">
                        <h3 className="text-primary">Branches</h3>
                        <span className="d-flex align-items-center gap-2">
                            <input
                                type="text"
                                placeholder="Search Branches"
                                className="form-control"
                                value={search}
                                style={{ width: "220px" }}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <button type="button" onClick={() => {
                                setSelectedBranch(null);
                                setModalHeading('Create New Branch');// No supplier means we are adding a new one
                                setShowModal(true);
                            }} className="btn btn-primary">Add New</button>
                        </span>
                    </div>
                    <div className="card-body">
                        {/* Search Input */}


                        {/* Data Table */}
                        <div className="table-responsive">
                            <DataTable
                                className="table-hover custom-table"
                                columns={columns}
                                data={filteredBranches} // Use filtered data
                                pagination
                                striped
                                progressPending={loading}
                                customStyles={customTableStyles}
                            />
                        </div>

                        {/* Error Message */}
                        {error && <p className="text-danger mt-2">Error: {error}</p>}
                    </div>
                </div>
            </div>
            <AddEditBranch show={showModal} branches={branches} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedBranch} />
        </div>
    );
}

export default Branches;
